import { render, staticRenderFns } from "./item_send.vue?vue&type=template&id=bdfa9af8&scoped=true"
import script from "./item_send.vue?vue&type=script&lang=ts"
export * from "./item_send.vue?vue&type=script&lang=ts"
import style0 from "./item_send.vue?vue&type=style&index=0&id=bdfa9af8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfa9af8",
  null
  
)

export default component.exports